import { Record } from 'immutable';
export default Record({
  index: undefined,
  render: undefined
});